module.exports = __webpack_public_path__ + "img/itt.5a66e91f.png";